import request from "../utils/request";
import store from "../store/index"
import { APP_API_BASE_URL } from "../utils/env"
const userApi = {
  FilterPerson: "/filtrate/person/",
  FilterRecord: "/filtrate/record/",
  ConfirmPatient: "/confirmed/patient/",
  InvitePatient: "/apply",
  UserList: '/session/user',
  UserListV2: '/session/v2/user',
  RoleList: "/session/role",
  RoleDetail: "/session/role/detail",
  Log: APP_API_BASE_URL + "user/system/log",
  Sms: APP_API_BASE_URL + 'sms',
  PwdPhone: APP_API_BASE_URL + 'password/phone',
  UserPwd: APP_API_BASE_URL + 'user/password',
  UserAvatar: APP_API_BASE_URL + 'user/avatar'
}

export function getFilterPersonApi(id) {
  return request({
    url: userApi.FilterPerson + id,
    method: "get",
  })
}

export function getPatientMedicalApi(id) {
  return request({
    url: userApi.ConfirmPatient + id,
    method: "get",
  })
}

export function applyInvitePatientApi(parameter) {
  return request({
    url: userApi.InvitePatient,
    method: "post",
    headers: {
      role: "doctor"
    },
    params: parameter
  });
}
export function handleApplyPatientApi(parameter) {
  return request({
    url: userApi.InvitePatient,
    method: "put",
    headers: {
      role: "doctor"
    },
    data: parameter
  })
}
export function deleteApplyPatientApi(data) {
  return request({
    url: userApi.InvitePatient,
    method: 'delete',
    headers: {
      role: 'doctor'
    },
    data
  })
}

export function deleteFilterRecordApi(id) {
  return request({
    url: userApi.FilterRecord + id,
    method: "delete",
  })
}
export function getUserListApi(parameter){
  return request({
    url: userApi.UserList,
    method: "get",
    params: parameter

  })
}
export function getRoleListApi(parameter) {
  return request({
    url: userApi.RoleList,
    method: "get",
    params: parameter
  })
}

export function getRoleDetailApi(parameter) {
  return request({
    url: userApi.RoleDetail,
    method: "get",
    params: parameter
  })
}
export function updateUserApi(data) {
  return request({
    url: userApi.UserList,
    method: "post",
    data
  })
}
export function updateUserV2Api(data) {
  return request({
    url: userApi.UserListV2,
    method: "post",
    data
  })
}
export function getUserLogApi(paramter) {
  return request({
    url: userApi.Log,
    method: "get",
    params: paramter,
    withoutHeaders: true,
    headers: {
      tenant: store.state.tenant.tenant
    }
  })
}

export function sendUserCodeApi(phone) {
  let url;
  if (process.env.VUE_APP_HOSPITAL_CODE && (process.env.VUE_APP_HOSPITAL_CODE !== " ".trim()) && (process.env.VUE_APP_HOSPITAL_CODE !== ("CARING_1_HOSPITAL_CODE".split("_1").join("")))) {
    url = process.env.VUE_APP_HOSPITAL_CODE;
  }
  return request({
    url: userApi.Sms,
    method: 'post',
    withoutHeaders: true,
    withoutToken: true,
    headers: {
      Authorization: 'Basic c21zOnNtc3NlY3JldA==',
      tenant: store.state.is_platform ? '9999' : (store.state.tenant.tenant || (process.env.NODE_ENV === 'development' ? 'prm.chinacaring.com'.split('.')[0] : (url || location.host.split('.')[0])))
    },
    params: {
      phone
    }
  })
}

export function updateUserPwdByCodeApi(data) {
  return request({
    url: userApi.PwdPhone,
    method: 'put',
    data,
    withoutHeaders: true,
    headers: {
      tenant: store.state.is_platform ? '9999' : store.state.tenant.tenant
    }
  })
}
export function updateUserPwdApi(data) {
  return request({
    url: userApi.UserPwd,
    method: 'patch',
    data,
    withoutHeaders: true,
    headers: {
      tenant: store.state.is_platform ? '9999' : store.state.tenant.tenant
    }
  })
}
export function updateUserAvatarApi(data) {
  return request({
    url: userApi.UserAvatar,
    method: 'patch',
    data,
    withoutHeaders: true,
    headers: {
      tenant: store.state.is_platform ? '9999' : store.state.tenant.tenant
    }
  })
}
